import { render, staticRenderFns } from "./AzconCalendarCard.vue?vue&type=template&id=19823418&scoped=true"
import script from "./AzconCalendarCard.vue?vue&type=script&lang=js"
export * from "./AzconCalendarCard.vue?vue&type=script&lang=js"
import style0 from "./AzconCalendarCard.vue?vue&type=style&index=0&id=19823418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19823418",
  null
  
)

export default component.exports